export const myInfoCardContents = {
  labels: {
    myInfoTitle: "My Info Card",
    completeProfileInfo: "Complete your Profile Info",
    incompleteProfileNote:
      "You are few steps away in completing your Profile section, so get head start by doing it now.",
    noInfo: "No information on profile"
  },
  buttons: {
    getStarted: "Get Started"
  }
};
